import { HttpErrorResponse } from "@angular/common/http";

export const getHttpErrorMessage = (error: unknown, fallback = ""): string => {
  const body = error instanceof HttpErrorResponse ? error.error as unknown : error;
  const response = getRecordProperty(body, "response") ?? getRecordProperty(error, "response");

  return getStringProperty(body, "message")
    ?? getStringArrayMessage(body, "message")
    ?? (response ? getStringProperty(response, "message") ?? getStringArrayMessage(response, "message") : null)
    ?? fallback;
};

const getRecordProperty = (value: unknown, property: string): Record<string, unknown> | null => {
  if (!isRecord(value)) return null;
  const propertyValue = value[property];
  return isRecord(propertyValue) ? propertyValue : null;
};

const getStringProperty = (value: unknown, property: string): string | null => {
  if (!isRecord(value)) return null;
  const propertyValue = value[property];
  return typeof propertyValue === "string" ? propertyValue : null;
};

const getStringArrayMessage = (value: unknown, property: string): string | null => {
  if (!isRecord(value)) return null;
  const propertyValue = value[property];
  if (!Array.isArray(propertyValue)) return null;
  const strings = propertyValue.filter((item): item is string => typeof item === "string");
  return strings.length > 0 ? strings.join(". ") : null;
};

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null;
